import React from "react";
import Fade from "react-reveal/Fade";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import VerificaToken from "../../components/VerificaToken";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import axios from "axios";

function AggiungiPatente() {
  let history = useHistory();

  const { user, setUser } = VerificaToken();

  const initialValues = {
    nominativo: "",
    scadenzaPatente: "",
    codicePatente: "",
    dataRilascio: "",
  };

  const validationSchema = Yup.object().shape({
    nominativo: Yup.string()
      .required("Devi compilare questo campo!")
      .min(3, "Valore non valido: Troppo corto!")
      .max(20, "Valore non valido: Troppo lungo!"),
    codicePatente: Yup.string("Devi inserire solamente numeri!")
      .required("Devi compilare questo campo!")
      .min(6, "Valore non valido: Troppo corto!")
      .max(6, "Valore non valido: Troppo lungo!"),
    scadenzaPatente: Yup.date().required("Devi compilare questo campo!"),
    dataRilascio: Yup.date().required("Devi compilare questo campo!"),
  });

  const onSubmit = (data) => {
    axios
      .put(
        `https://website-8bit-motors.herokuapp.com/account/info/${user.id}/aggiungiPatente`,
        data
      )
      .then(() => {
        axios
          .get(
            `https://website-8bit-motors.herokuapp.com/account/info/${user.id}`
          )
          .then((res) => {
            setUser(res.data);
            history.push(`/account/info/${user.id}`);
          });
      });
  };

  return (
    <Container fluid>
      {/* SEZIONE BANNER */}
      <Container
        fluid
        id="banner_recovered"
        className="head-banner text-center text-white"
      >
        <Container>
          <Row>
            <Col>
              <h1>
                <strong>8-Bit Motors</strong>
              </h1>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container className="text-center">
        <h2 className="mt-3">Aggiungi Patente</h2>
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          <Form>
            <Row>
              <Col>
                <Fade left>
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="nominativo"
                  >
                    Nominativo
                  </label>
                  <ErrorMessage name="nominativo" component="h6" />
                  <Field
                    type="text"
                    className="form-control input_registrazione"
                    name="nominativo"
                    placeholder="Mario Rossi"
                  />
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="scadenzaPatente"
                  >
                    Scadenza Patente
                  </label>
                  <ErrorMessage name="scadenzaPatente" component="h6" />
                  <Field
                    type="date"
                    className="form-control input_registrazione"
                    name="scadenzaPatente"
                    placeholder="01/01/2000"
                  />
                </Fade>
              </Col>
              <Col>
                <Fade right>
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="codicePatente"
                  >
                    Codice Patente
                  </label>
                  <ErrorMessage name="codicePatente" component="h6" />
                  <Field
                    type="text"
                    className="form-control input_registrazione"
                    name="codicePatente"
                    placeholder="48U34L2"
                  />
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="dataRilascio"
                  >
                    Data Rilascio
                  </label>
                  <ErrorMessage name="dataRilascio" component="h6" />
                  <Field
                    type="date"
                    className="form-control input_registrazione"
                    name="dataRilascio"
                    placeholder="01/01/2000"
                  />
                </Fade>
              </Col>
            </Row>
            <Button type="sumbit" className="mt-4" variant="success">
              Conferma
            </Button>
          </Form>
        </Formik>
      </Container>
      <br />
      <br />
      <br />
    </Container>
  );
}

export default AggiungiPatente;
